import React, { useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
  Breadcrumb,
  Col,
  Row,
  Spinner,
  Dropdown
} from "react-bootstrap";
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik } from "formik";
import useReactRouter from "use-react-router";
import {
  // faChevronRight,
  // faAdd,
  faTrash,
  faClock,
  // faCoins,
  faPlus,
  faSave,
  // faClose,
  // faCheck,
  // faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import no_product from "../../../image/no_product.png";
import Group from "../../../image/Group.png";
// import Rectangle from "../../../image/Rectangle775.png";
// import Ellipse2 from "../../../image/Ellipse.png";
// import { faFacebook, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { useToasts } from "react-toast-notifications";
import { COLOR_APP, COLOR_APP_CANCEL, SHOPID } from "../../../constants";
import _ from "lodash";
import { imageRender } from "../../../helpers";
// import AnimationLoading from "../../../components/AnimationLoading";
import { useLazyQuery, useMutation } from "@apollo/client";
// import { CREATE_LIVE, UPDATE_LIVE } from "../../../graphql/live/mutation";
import { GET_POST_STOCKS } from "../../../graphql/postStock/query";
import { GET_STOCKS } from "../../../graphql/stock/query";
// import {
//   CREATE_LIVE_STOCK,
//   DELETE_LIVE_STOCK,
//   UPDATE_LIVE_STOCK,
// } from "../../../graphql/liveStock/mutation";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
// import { useStore } from "../../../store";
import { CREATE_POST, UPDATE_POST } from "../../../graphql/post/mutation";
import { CREATE_MANY_POST_STOCK, CREATE_POST_STOCK, DELETE_POST_STOCK, UPDATE_MANY_POST_STOCK, UPDATE_POST_STOCK } from "../../../graphql/postStock/mutation";
// import { createStock, deletePostStock } from "../../../graphql/mutations";
import { connect } from "react-redux";
import "./PostFeetAdd.css";
import moment from "moment";
import { useInitFbSDK } from "../../../helpers/fb-hooks";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from "react-icons/md";
import PaginationsV1 from "../../../components/PaginationV1";

function PostFeedAdd({ props }) {
  const { height, width } = useWindowDimensions();
  const { addToast } = useToasts();
  const shopPageCookie = Cookies.get('SHOP_PAGE');
  const assignedPageList = shopPageCookie ? JSON.parse(shopPageCookie) : [];
  // const shopPageCookie = [{ "access_token": "EAAJ4D9SoBDsBOyl95VD4RZA36tWrqYx4ZBdPIAjc0PjlQLczksB3PvGjhsJopO0AZAnilHYsxveZAZBMoUVyxCzRjuF3w7lakZCfRYBTzs7m1kWhABgfDKEdEAJa0t1CFSyZBINcOVqEjoCFnJ8keWPSOZCAVsA2heXV9PUE95R3lMYNCVucaDM8V6Uv1ERP3c5OZBQ4WtxkATYs6ZBw8ZD", "category": "Software", "category_list": [{ "id": "2211", "name": "Software" }], "name": "Sala Technology", "id": "108526298830349", "tasks": ["ADVERTISE", "ANALYZE", "CREATE_CONTENT", "MESSAGING", "MODERATE", "MANAGE"] }, { "access_token": "EAAJ4D9SoBDsBO2wt5rNDh8fOJkhr35yva9TP3EtNtJTPWeqZBNX2GA2VH7YNge2kKZAZBqzgNo0XNjPdIoVarWdihVZBT2ULVdTAMkQGeZALJUGRirLWcfZBGOnkNls89UDJdDXK5sKepQ9K00nvX12svpGtWORknOBeXHX7UZCbRC6xe5ZCNL5uA71JVudjmbqx4Iwm4UaFhoZBqd0gZD", "category": "Health/beauty", "category_list": [{ "id": "2214", "name": "Health/beauty" }], "name": "Chii Pam-Ict", "id": "111263485024331", "tasks": ["ADVERTISE", "ANALYZE", "CREATE_CONTENT", "MESSAGING", "MODERATE", "MANAGE"] }, { "access_token": "EAAJ4D9SoBDsBOx5vPFIoeDyNUBoiZBxZArqeg4svepo60KKYGu6ZCRk9ARHOXpaj3RFstZAwnAstsJ2npzzmaISZAQZCz9I2oa2Rv60wqk9Qs5qgg48TL46bzSE19QyepmZCRJEjdlykZCtGZAHLweyNEbrBduZC00OEbWhsHFBzQjKSQyCbDdCqzZBfLtc0Gt9v4PBp7QbIVscZCwJtJCAZD", "category": "Software Company", "category_list": [{ "id": "1065597503495311", "name": "Software Company" }], "name": "Lailao Learn - ລະບົບຈັດການໂຮງຮຽນ", "id": "102469749097262", "tasks": ["ADVERTISE", "ANALYZE", "CREATE_CONTENT", "MESSAGING", "MODERATE"] }];


  // const assignedPageList = shopPageCookie;
  // const assignedPageList = JSON.parse(Cookies.get('SHOP_PAGE'))  || [];
  // const assignedPageList = JSON.parse(localStorage.getItem('SHOP_PAGE'));

  const { history, location } = useReactRouter();
  const [showGuide, setShowGuide] = useState(false);
  const [stockList, setStockList] = useState([]);
  const [stockTotal, setStockTotal] = useState();
  const [editMode, setEditMode] = useState(false);
  const [liveData, setLiveData] = useState();
  const [postStocks, setPostStocks] = useState([]);
  const [arrSameCode, setArrSameCode] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isRemoveAll, setIsRemoveAll] = useState(false);
  const [dataFromSelect, setDataFromSelect] = useState([]);
  const [selectedPage, setSelectedPage] = useState();
  const [selectedFeed, setSelectedFeed] = useState();
  const [assignedPageFeed, setAssignedPageFeed] = useState();
  const [originAssignedPageFeed, setOriginAssignedPageFeed] = useState();
  const [showSelect, setShowSelect] = useState(false);
  const [selectedPageName, setSelectedPageName] = useState();
  const [selectedPageId, setSelectedPageId] = useState();
  const [selectedPostDescription, setSelectedPostDescription] = useState("");
  const [selectedPostId, setSelectedPostId] = useState();
  const [selectedPostIds, setSelectedPostIds] = useState();
  const [showPost, setShowPost] = useState(false);
  // const [showPageName, setShowPageName] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFeed, setIsLoadingFeed] = useState(false);
  const [showStockModal, setshowStockModal] = useState(false);
  const [fbUserAccessToken, setFbUserAccessToken] = useState();
  // const [selectedStock, setSelectedStock] = useState([]);
  const [searchPostKeyword, setSearchPostKeyword] = useState()
  // const isFbSDKInitialized = useInitFbSDK();

  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState([]);

  const callFBSDK = async () => {
    await useInitFbSDK;
  }


  const [getUserStocks, { loading: userStockLoading, data: userStockData }] =
    useLazyQuery(GET_STOCKS, { fetchPolicy: "cache-and-network" });
  const [getLiveStocks, { data: userLiveStockData, loading: loadingPostStock }] = useLazyQuery(
    GET_POST_STOCKS,
    { fetchPolicy: "cache-and-network" }
  );
  const [createPost] = useMutation(CREATE_POST);
  const [updatePost] = useMutation(UPDATE_POST);
  const [createPostStock] = useMutation(CREATE_POST_STOCK);
  const [createManyYPostStock] = useMutation(CREATE_MANY_POST_STOCK);
  // const [updatePostStock] = useMutation(UPDATE_POST_STOCK);
  const [updatePostStock] = useMutation(UPDATE_MANY_POST_STOCK);
  // const [updateManyPostStock] = useMutation();
  const [updateStock] = useMutation(UPDATE_STOCK);
  const [deletePostStock] = useMutation(DELETE_POST_STOCK);


  // add pagination
  const [perPageLimit, setPerPageLimit] = useState(150);
  const [page, setPage] = useState(0);
  const pageAll = stockTotal > 0 ? Math.ceil(stockTotal / perPageLimit) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);


  useEffect(() => {
    callFBSDK()
    getFacebookLoginStatus();
    if (!location?.state) history.goBack();
    setEditMode(location?.state?.editMode ?? false);
  }, []);

  useEffect(() => {
    getUserStock();
  }, [page, perPageLimit]);

  useEffect(() => {
    if (editMode) {
      setLiveData(location?.state?.data ?? {});
      getLiveStock(location?.state?.data?.id)
    }
  }, [editMode]);

  useEffect(() => {
    if (!searchPostKeyword) return setAssignedPageFeed(originAssignedPageFeed);

    const _newPostFeed = originAssignedPageFeed.filter(({ message }) => (searchPostKeyword?.includes(message) || message?.includes(searchPostKeyword)))
    setAssignedPageFeed(_newPostFeed);
  },
    [searchPostKeyword])

  const getLiveStock = async (_postId) => {
    try {
      await getLiveStocks({
        variables: {
          where: {
            // post: liveData?.id,
            post: _postId,
            isDeleted: false
          },
          skip: 0,
          limit: 50,

        },
      });
    } catch (error) {
      console.log("Error retrieving posts", error);
    }
  };

  useEffect(() => {
    if (userStockData?.stocks) {
      setStockTotal(userStockData?.stocks?.total);

      // Filter stocks with non-empty cfMessage
      const _newStockList = userStockData?.stocks?.data.filter(
        (data) => data?.cfMessage && !_.isEmpty(data?.cfMessage)
      );

      setStockList(_newStockList);
    }
  }, [userStockData]);

  useEffect(() => {
    if (userLiveStockData?.postStocks?.data) {
      let _userStockData = userLiveStockData?.postStocks?.data;
      let _validateLiveStock = _userStockData.map((lStock) => {
        return {
          ...lStock,
          validateAmount: lStock?.amount,
        };
      });
      setPostStocks(_validateLiveStock);
    }
  }, [userLiveStockData]);

  useEffect(() => {
    // set page id and page name if edit post
    setSelectedPageId(liveData?.page);
    setSelectedPageName(liveData?.pageName);
    // set post id and description if editpost
    setSelectedPostId(liveData?.fbFeedId);
    setSelectedPostIds(liveData?.fbFeedIds);
    setSelectedPostDescription(liveData?.description)

    let _selectPageFilter = _.filter(assignedPageList, {
      id: liveData?.page,
    });
    setSelectedPage(_selectPageFilter[0])
  }, [liveData])

  useEffect(() => {
    getFacebookLoginStatus();
  }, [assignedPageList])


  // Function to fetch data from Facebook API
  const _getPost = async (url, i) => {
    if (!selectedPage) return;

    try {
      setIsLoadingFeed(true);
      await window.FB.api(url, function (response) {
        if (response && !response.error) {
          setAssignedPageFeed(response?.data); // Set the posts
          setOriginAssignedPageFeed(response?.data)
          setNextPage(response?.paging?.next);  // Save next page URL
          if (!i) {
            setPrevPage((prevState) => [
              ...prevState,
              { url: response?.paging?.next, index: i ? i + 1 : prevState.length + 1 }
            ]);
          }
          setIsLoadingFeed(false);
        }
      });
    } catch (err) {
      setIsLoadingFeed(false);
      console.log(err);
    }
  };


  // Fetch initial posts when the component mounts
  useEffect(() => {
    if (selectedPage) {
      let initialUrl = `/me/feed?access_token=${selectedPage.access_token}&limit=50&fields=id,message,created_time,full_picture,attachments{subattachments.limit(80)}`;
      _getPost(initialUrl);
    }
  }, [selectedPage]);

  // Handle Next button click
  const handleNextPage = () => {
    if (nextPage) {
      _getPost(nextPage);
    }
  };

  // Handle Prev button click
  const handlePrevPage = () => {
    if (prevPage.length > 1) {
      // Get the largest index and fetch that page
      const largestIndex = Math.max(...prevPage.map(p => p.index));
      if (largestIndex === 2) {
        let initialUrl = `/me/feed?access_token=${selectedPage.access_token}&limit=50&fields=id,message,created_time,full_picture,attachments{subattachments.limit(80)}`;
        _getPost(initialUrl, false);
        setPrevPage([]);
        return;
      }
      let _newLargestIndex = largestIndex - 2;
      const prevPageData = prevPage.find(p => p.index === _newLargestIndex);
      if (prevPageData) {

        // Remove the last URL after going back
        setPrevPage(prevPage.filter(p => p.index !== largestIndex));
        _getPost(prevPageData.url, true);
      }
    }
  };

  const getUserStock = async () => {
    try {
      let SHOP_ID = await localStorage.getItem("SHOP");
      await getUserStocks({
        variables: {
          where: {
            isDeleted: false,
            shop: SHOP_ID,
            amount: 1
          },
          orderBy: "createdAt_DESC",
          // limit: 2000,
          // skip: 0,
          limit: perPageLimit,
          skip: page * perPageLimit,
        },
      });
    } catch (error) {
      console.log("Error retrieving posts", error);
    }
  };



  // this is my new code 
  const _createPost = async () => {
    try {
      if (isLoading) return;
      let isMessageEmpty = false;
      let isAmountEmpty = false;
      let _postStocks = [];

      // Validate postStocks
      postStocks.forEach((postStock) => {
        if (!postStock.cfMessage) isMessageEmpty = true;
        if (!postStock.amount) isAmountEmpty = true;
      });

      if (postStocks.length === 0) {
        addToast("ເພີ່ມສິນຄ້າຈະຂາຍໃນໂພສກ່ອນບັນທຶກ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      if (isMessageEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໂພສຕ້ອງກໍານົດລະຫັດຊີເອຟ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      if (isAmountEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໂພສຕ້ອງມີຈໍານວນຫຼາຍກວ່າ 1​ ອັນ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      setIsLoading(true);
      const SHOP_ID = await localStorage.getItem("SHOP");

      // Create the post
      let afterCreatedPost = await createPost({
        variables: {
          data: {
            isDeleted: false,
            status: "CREATED",
            page: selectedPageId,
            pageName: selectedPageName,
            fbFeedId: selectedPostId,
            fbFeedIds: selectedPostIds,
            description: selectedPostDescription ?? "-",
            shop: SHOP_ID,
          },
        },
      });

      let _postId = afterCreatedPost?.data?.createPost?.id;

      // Prepare _postStocks array
      _postStocks = postStocks.map((postStock) => ({
        amount: postStock.amount,
        amountAll: postStock.amount,
        cfMessage: postStock.cfMessage,
        cfCode: postStock.cfMessage.toUpperCase(),
        stock: postStock.stock?.id,
        post: _postId,
        // post: "66cd562dc406210013fd9bd8",
        fbFeedId: selectedPostId,
        isDeleted: false,
        shop: SHOP_ID,
      }));

      // Create post stocks
      const resCreate = await createManyYPostStock({
        variables: {
          data: _postStocks,
        },
      });

      if (resCreate?.data?.createManyPostStock?.message) {
        addToast("ເພີ່ມໂພສສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        history.goBack();
      }
      setIsLoading(false);

    } catch (err) {
      setIsLoading(false);
      console.log("error creating todo:", err);
      addToast("ມີຂໍ້ຜິດພາດໃນການເພີ່ມໂພສ", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const _editPost = async () => {
    try {
      if (isLoading) return;
      //Check if cfMessage is empty
      let isMessageEmpty = false;
      let isAmountEmpty = false;
      let _postStocks = [];

      postStocks.map(async (postStock, index) => {
        if (!postStock.cfMessage) isMessageEmpty = true;
        if (!postStock.amount) isAmountEmpty = true;
      });
      if (postStocks.length == 0) {
        addToast("ເພີ່ມສິນຄ້າຈະຂາຍໃນໄລຟກ່ອນບັນທຶກ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      if (isMessageEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໄລຟຕ້ອງກໍານົດລະຫັດຊີເອຟ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      if (isAmountEmpty) {
        addToast("ສິນຄ້າຈະຂາຍໃນໂພສຕ້ອງມີຈໍານວນຫຼາຍກວ່າ 1​ ອັນ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      setIsLoading(true);
      const SHOP_ID = await localStorage.getItem("SHOP");



      //Update post
      await updatePost({
        variables: {
          where: {
            id: liveData?.id
          },
          data: {
            page: selectedPageId,
            pageName: selectedPageName,
            fbFeedId: selectedPostId,
            fbFeedIds: selectedPostIds,
            description: selectedPostDescription ?? "-",
            shop: SHOP_ID,
          }
        },
      });

      // Prepare _postStocks array update
      _postStocks = postStocks.map((postStock) => ({
        amount: postStock.amount,
        amountAll: postStock.amount,
        cfMessage: postStock.cfMessage,
        cfCode: postStock.cfMessage.toUpperCase(),
        stock: postStock.stock?.id,
        fbFeedId: selectedPostId,
        isDeleted: false,
        shop: SHOP_ID,
        id: postStock.id,
      }));

      //Update post Stock
      await updatePostStock({
        variables: {
          where: {
            id: location?.state?.data?.id,
          },
          data: _postStocks,
        },
      });

      setIsLoading(false);
      addToast("ແກ້ໄຂໄລຟສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
      history.goBack();
    } catch (err) {
      setIsLoading(false);
      console.log("error creating todo:", err);
      addToast("ມີຂໍ້ຜິດພາດໃນການເພີ່ມໄລຟ", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const _addStockToLive = (stock) => {
    console.log(stock?.id)
    let _newPostStock = {
      stock,
      amount: stock.amount,
      amountAll: stock.amount,
      validateAmount: 0,
      cfMessage: stock?.cfMessage ?? "",
    };

    let _postStocks = [...postStocks];
    if (checkStockIsAdded(stock)) {
      // _.remove(_postStocks, { stock });
      // setPostStocks(_postStocks);
      // setIsSelectAll(false);
      addToast("ມີຢູ່ໃນລາຍການໄລຟແລ້ວບໍ່ສາມາດເພີ່ມຕື່ມໄດ້", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    _postStocks.push(_newPostStock);
    setPostStocks(_postStocks);
    return;
  };

  const checkStockIsAdded = (stock) => {
    let _postStocks = [...postStocks];
    let isDuplicated = false;
    _postStocks.map((lStock, index) => {
      if (lStock?.stock?.id == stock?.id) isDuplicated = true;
    });
    return isDuplicated;
  };

  const checkStockIsAddedOnPhone = (stock) => {
    let _postStocks = [...dataFromSelect];
    let isDuplicated = false;
    _postStocks.map((lStock, index) => {
      if (lStock?.stock?.id == stock?.id) isDuplicated = true;
    });
    return isDuplicated;
  };

  const _removeStockFromLive = async (stock) => {
    let _postStocks = [...postStocks];
    let _removeLiveStock = _.remove(_postStocks, stock);

    if (_removeLiveStock[0].id) {
      await deletePostStock({
        variables: {
          where: {
            id: _removeLiveStock[0]?.id,
          },
        },
      });
      // await updateStock({
      //   variables: {
      //     where: {
      //       id: _removeLiveStock[0]?.stock?.id,
      //     },
      //     data: {
      //       amount:
      //         _removeLiveStock[0]?.stock?.amount + _removeLiveStock[0]?.amount,
      //       isUsing: false
      //     },
      //   },
      // });

      let _stockList = [...stockList];
      _stockList = _stockList.map((stock) => {
        if (_removeLiveStock[0]?.stock?.id == stock.id) {
          return {
            ...stock,
            amount: _removeLiveStock[0]?.amount + stock?.amount,
          };
        } else return stock;
      });
      setStockList(_stockList);
    }

    setPostStocks(_postStocks);
  };

  const _liveStockChange = (stock, index, e) => {
    let _postStocks = [...postStocks];

    //Check amount is less than stock
    // console.log(_postStocks[index])
    if (
      _postStocks[index].validateAmount + _postStocks[index].stock.amount <
      parseInt(e.target.value)
    ) {
      addToast("ຈໍານວນຂາຍຕ້ອງບໍ່ເກີນໃນສະຕ໋ອກ!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    if (parseInt(e.target.value) <= 0) {
      addToast("ຕ້ອງຕ້ອງຈໍານວນຕ້ອງການຂາຍຫຼາຍກວ່າຫນຶ່ງຊິ້ນ!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    _postStocks[index] = {
      ..._postStocks[index],
      amount: parseInt(e.target.value),
      amountAll: parseInt(e.target.value),
    };
    setPostStocks(_postStocks);
  };

  const _liveStockCFMessageChange = (stock, index, e) => {
    var n = e.target.value.includes("/");
    if (n) {
      addToast("ລະຫັດCFຕ້ອງບໍ່ມີອັກສອນ '/' (ສະແລັສ) ປົນຢູ່!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    let _postStocks = [...postStocks];

    //Check Duplicate CFMessage
    let _isDuplicated = false;
    _postStocks.map((lStock, index) => {
      if (lStock.cfMessage != "" && lStock.cfMessage == e.target.value) {
        _isDuplicated = true;
      }
    });

    if (_isDuplicated) {
      let _arrSameCode = [...arrSameCode];
      _arrSameCode.push(index);
      setArrSameCode(_arrSameCode);
      addToast("ລະຫັດCFຕ້ອງບໍ່ຊໍ້າກັນ​!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    } else {
      let _arrSameCode = arrSameCode.filter((item) => item != index);
      setArrSameCode(_arrSameCode);
    }

    _postStocks[index] = {
      ..._postStocks[index],
      cfMessage: e.target.value,
    };
    setPostStocks(_postStocks);
  };

  const checkSameCode = (index) => arrSameCode.filter((item) => item == index);

  const _updateListStock = async (value) => {
    try {
      const SHOP_ID = await localStorage.getItem("SHOP");
      if (value) {
        await getUserStocks({
          variables: {
            where: {
              isDeleted: false,
              OR: [{ name: value }, { cfMessage: value }],
              shop: SHOP_ID,
              amount: 1
            },
            orderBy: "createdAt_DESC",
            limit: 50,
            skip: 0,
          },
        });
      } else {
        await getUserStocks({
          variables: {
            where: {
              isDeleted: false,
              shop: SHOP_ID,
              amount: 1
            },
            orderBy: "createdAt_DESC",
            limit: 50,
            skip: 0,
          },
        });
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const onSelectStock = (stock) => {
    // const _stockList = dataFromSelect;

    let _postStocks = [...dataFromSelect];
    if (checkStockIsAddedOnPhone(stock)) {
      _.remove(_postStocks, { stock });
      setDataFromSelect(_postStocks);
      setIsSelectAll(false);
      return;
    }
    _postStocks.push({
      stock: stock,
      amount: stock?.amount,
      amountAll: stock?.amount,
      validateAmount: 0,
      cfMessage: stock?.cfMessage ?? "",
    })
    setDataFromSelect(_postStocks)

    setIsSelectAll(_postStocks?.length === stockList?.length)
  }

  const onSeletedAllStocks = async () => {
    if (isSelectAll) {
      setDataFromSelect([]);
      setIsSelectAll(false);
    } else {
      let _stockList = [];
      for (var i = 0; i < stockList.length; i++) {
        let postStockIndex = postStocks.findIndex((pStock => pStock?.stock?.id === stockList[i]?.id));
        if (postStockIndex < 0)
          _stockList.push({
            stock: stockList[i],
            amount: stockList[i].amount,
            amountAll: stockList[i].amount,
            validateAmount: 0,
            cfMessage: stockList[i]?.cfMessage ?? "",
          });
      }
      setDataFromSelect(_stockList);
      setIsSelectAll(true);
    }
  };

  const onRemoveAllStocks = async () => {
    // console.log("stockList: ", stockList)
    if (isRemoveAll) {
      setDataFromSelect([]);
      setIsRemoveAll(false);
    } else {

      setIsRemoveAll(true);
    }
  };

  const onAddAllStocksToPost = async (e) => {
    if (dataFromSelect.length > 0) {
      let _postStocks = [...dataFromSelect, ...postStocks];
      setPostStocks(_postStocks);
      setIsSelectAll(false);
      setshowStockModal(false);
      setDataFromSelect([]);
      // setIsAddAll(true)
    }
  };

  const onRemoveAllStocksToPost = async () => {
    setPostStocks([]);
    setIsRemoveAll(false);
  };

  const _changeSeletedPage = async (e) => {
    let _selectPageFilter = _.filter(assignedPageList, {
      id: e.target.value,
    });
    // setSelectedPage(_selectPageFilter[0]);
    setSelectedPage(_selectPageFilter[0])
  };

  const _changeSeletedFeed = async (postId) => {
    // console.log("assignedPageFeed: ", assignedPageFeed);
    // console.log("e.target.value: ", e.target.value);

    let _selectPageFilter = _.filter(assignedPageFeed, {
      id: postId,
    });

    setSelectedFeed(_selectPageFilter[0]);
  };

  const _goToYoutube = () => {
    window.open("https://www.youtube.com/watch?v=AUZw4n44Dfo", "_blank");
  };

  const _onSavePostFeed = () => {
    setPrevPage([]);
    setNextPage()
    if (!selectedFeed) return triggerHidePost();
    // setLiveData({ ...liveData, pageName: selectedPage?.name ?? liveData?.pageName });
    setSelectedPostDescription(selectedFeed?.message ?? "-");
    setSelectedPostId(selectedFeed?.id.split("_")[1] ?? "");
    let _newFeedIds = [selectedFeed?.id.split("_")[1]];
    if (_.isEmpty(selectedFeed?.attachments?.data[0]?.subattachments)) {
      triggerHidePost();
      setSelectedPostIds(_newFeedIds);
      // console.log({ _newFeedIds })
      return
    }

    for (let i in selectedFeed?.attachments?.data[0]?.subattachments?.data) {
      _newFeedIds = [..._newFeedIds, selectedFeed?.attachments?.data[0]?.subattachments?.data[i]?.target?.id]
    }
    setSelectedPostIds(_newFeedIds);
    // console.log({ _newFeedIds })
    triggerHidePost();
  }

  const _onSavePage = () => {
    if (assignedPageList?.length === 0 || !selectedPage) return triggerHideSelectPage();
    // setLiveData({ ...liveData, pageName: selectedPage?.name ?? liveData?.pageName });
    setSelectedPageName(selectedPage?.name ?? "");
    setSelectedPageId(selectedPage?.id ?? "");
    triggerHideSelectPage();
  }

  const getFacebookLoginStatus = () => {
    try {
      window.FB.getLoginStatus((response) => {
        if (response.authResponse)
          setFbUserAccessToken(response.authResponse.accessToken);
      });
    } catch (error) {
      console.log("Error FACEBOOK STATUS", error);
    }
  };

  const flitterStock = async (data) => {
    if (data.length > 0) {
      const _stockList = data.filter((item) => item.amount > 0);
      setStockTotal(_stockList.length ?? 0);
      setStockList(_stockList);
    } else {
      setStockTotal(0);
      setStockList([]);
    }
  };

  const triggerHidePost = () => setShowPost(false);
  const triggerShowPost = () => setShowPost(true);

  const triggerHideSelectPage = () => setShowSelect(false);
  const triggerShowSelect = () => setShowSelect(true);

  //console.log("assignedPageFeed Props: ", assignedPageList);
  if (userStockLoading && loadingPostStock) return <LoadingSpinner />

  // change perpage limit
  const handlePerPageChange = (limit) => {
    setPerPageLimit(limit); // Update the perPageLimit state
    setPage(0); // Reset page to 0 when perPageLimit changes
  };

  // const handleSelectThisPage = (item) => {
  //   console.log({ item })
  //   setSelectedPageName(item?.name)
  //   setLiveData({
  //     ...liveData,
  //     pageName: item?.name,
  //   });
  //   triggerHideSelectPage()
  // }


  return (
    <div>
      {
        width > 700 ? (<div>
          <div style={{ background: "#F1F1F1" }}>
            {/* {userStockLoading ? <AnimationLoading /> : <div />} */}

            <div
              style={{
                display: "flex",
                justifyItems: "center",
                padding: "27.5px 13.5px 16px 16px",
              }}
            >
              <div >
                <button
                  onClick={() => history.push("/post-feed")}
                  style={{
                    fontSize: "16px",
                    color: "#371895",
                    marginRight: "5px",
                    border: 'none',

                  }}
                >
                  <img
                    src={Group}
                    alt=""
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "7px",
                    }}
                  />
                  ຈັດການໂພສ
                </button>
              </div>
              <button
                style={{
                  margin: "0 10px",
                  fontSize: "16px",
                  color: "#252A31",
                  border: 'none',
                  cursor: "default",
                }}
              >
                {editMode ? '/ ແກ້ໄຂ' : ' / ສ້າງ'}ສິນຄ້າໃໝ່ໃນໂພສ
              </button>
            </div>


            {(!editMode || liveData) && (
              <Formik
                initialValues={{
                  title: liveData?.title || "",
                  description: liveData?.description || "",
                }}
                validate={(values) => {
                  // const errors = {};
                  // if (!values.phone) {
                  //     errors.phone = 'ກະລຸນາປ້ອນ Userid... !';
                  // }
                  // return errors;
                }}
                onSubmit={(values) => {
                  // if (!selectedPageId) return addToast(
                  //   "ກະລຸນາເລືອກ Page ໃດຫນຶ່ງກ່ອນ!",
                  //   {
                  //     appearance: "error",
                  //     autoDismiss: true,
                  //   }
                  // );
                  // if (!selectedPostId) return addToast(
                  //   "ກະລຸນາເລືອກ Post ໃດຫນຶ່ງກ່ອນ!",
                  //   {
                  //     appearance: "error",
                  //     autoDismiss: true,
                  //   }
                  // );
                  if (postStocks.length > 0) {
                    editMode ? _editPost() : _createPost();
                  } else {
                    // errorSwal("ກະລຸນາເລືອກສິນຄ້າເຂັ້າ Live ກ່ອນ ຈຶ່ງສາມາດເລີ່ມ Live ໄດ້!")
                    addToast(
                      "ກະລຸນາເລືອກສິນຄ້າເຂິ້າ Post ກ່ອນ ຈຶ່ງສາມາດເລີ່ມ Post ໄດ້!",
                      {
                        appearance: "error",
                        autoDismiss: true,
                      }
                    );
                  }
                }}
              >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  justifyItems: "center",
                  background: "#fff",
                  borderRadius: "6px",
                  margin: "0px 10px 0px 10px",
                  padding: "20px 10px 20px 10px",
                  whiteSpace: 'nowrap'
                }}>
                  <div className="row">
                    <div className="col-5" style={{ display: 'flex', alignItems: 'center' }}>
                      <div>ເພຈ: </div>
                      <div
                        style={{
                          background: "#F9F9F9",
                          width: "290px",
                          height: "46px",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyItems: "center",
                          verticalAlign: "centered",
                          marginLeft: 5,
                          paddingLeft: 5,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: 'nowrap',
                          maxLines: 2,
                        }}
                      >
                        {selectedPageName ? selectedPageName : liveData?.pageName === "undefined" || liveData?.pageName === "" ? "ກະລຸນາເລືອກເພຈກ່ອນ" : liveData?.pageName ?? "ກະລຸນາເລືອກເພຈກ່ອນ"}
                      </div>
                      <button className="btn-select" onClick={() => {
                        // if (!fbUserAccessToken) return addToast(
                        //   "ກະລຸນາເຊື່ອມ Facebook ກ່ອນ!",
                        //   {
                        //     appearance: "error",
                        //     autoDismiss: true,
                        //   }
                        // );
                        triggerShowSelect();
                      }}>ເລືອກເພຈ</button>
                    </div>
                    <div className="col-7" style={{ display: 'flex', alignItems: 'center' }}>
                      <div>ໂພສ:</div>
                      <div
                        style={{
                          background: "#F9F9F9",
                          width: "334px",
                          height: "46px",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyItems: "center",
                          verticalAlign: "centered",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: 'nowrap',
                          maxLines: 2,
                          marginLeft: 5,
                          paddingLeft: 5
                        }}
                      >
                        {selectedPostDescription ? selectedPostDescription : liveData?.description === "undefined" || liveData?.description === "" ? "ກະລຸນາເລືອກໂພສກ່ອນ" : liveData?.description ?? "ກະລຸນາເລືອກໂພສກ່ອນ"}
                      </div>
                      <button onClick={() => {
                        if (_.isEmpty(selectedPageId)) return addToast(
                          "ກະລຸນາເລືອກ Page ໃດຫນຶ່ງ ກ່ອນ!",
                          {
                            appearance: "error",
                            autoDismiss: true,
                          }
                        );
                        triggerShowPost();
                      }} className="btn-select">
                        ເລືອກໂພສ
                      </button>
                      <button
                        onClick={() => handleSubmit()}
                        style={{ background: COLOR_APP, flex: 'end', color: '#fff', border: 'none', padding: '8px 40px', borderRadius: '6px', marginLeft: 5 }}
                      // className="btn-create-live"
                      >
                        {isLoading ?
                          <Spinner
                            size="sm"
                            animation="border"
                          />
                          :
                          editMode ? 'ແກ້ໄຂໂພສ' : 'ສ້າງໂພສ'}
                      </button>
                    </div>
                  </div>

                </div>
              )}
              </Formik>
            )}
            <div className="product-container">
              <div className="product_wrapper">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <h1>ລາຍການສິນຄ້າ ({stockTotal || "0"})</h1>
                  <div className="control-wrapper">
                    <Button
                      // variant="outline-light"
                      style={{ background: "#F7F7F7", border: "none", color: "#422F90" }}
                      disabled={!isSelectAll}
                      className="add-product-btn"
                      onClick={() => onAddAllStocksToPost()}
                    >
                      <FontAwesomeIcon icon={faPlus} style={{ marginRight: 5 }} />
                      ເພີ່ມສິນຄ້າ
                    </Button>

                  </div>
                </div>
                <br />
                <div className="d-flex justify-content-center align-items-start gap-1">
                  <Dropdown>
                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                      ສະແດງ {perPageLimit}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handlePerPageChange(150)}>150/ໜ້າ</Dropdown.Item>
                      <Dropdown.Item onClick={() => handlePerPageChange(800)}>800/ໜ້າ</Dropdown.Item>
                      <Dropdown.Item onClick={() => handlePerPageChange(1000)}>1000/ໜ້າ</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <PaginationsV1
                    count={stockTotal}
                    perPageLimit={perPageLimit}
                    page={page}
                    pageAll={pageAll}
                    onPageChange={handleChangePage}
                    textNext=">"
                    textPrev="<"
                  />
                </div>
                {(userStockLoading && !userStockData) ? <LoadingSpinner /> :
                  <div>
                    <Table
                      style={{
                        marginTop: "20px",
                        borderCollapse: "collapse",
                        width: "100% ",
                      }}
                    >
                      <tbody>
                        <tr>
                          <th style={{ width: "1%" }}>
                            <input id="btn-disable" type="checkbox" checked={isSelectAll} onClick={() => onSeletedAllStocks()} />
                          </th>
                          <th style={{ width: "5%", textAlign: "center" }}>ຮູບ</th>
                          <th style={{ verticalAlign: "middle" }}> ຊື່ສິນຄ້າ</th>
                          <th style={{ verticalAlign: "middle" }}>ລະຫັດCF</th>
                          <th style={{ verticalAlign: "middle" }}>ຍັງເຫຼືອ</th>
                          <th style={{ verticalAlign: "middle" }}>ຈັດການ</th>
                        </tr>
                      </tbody>
                      <tbody>
                        {stockList.length > 0 &&
                          stockList?.map((stock, index) => (
                            <tr key={stock + index}>
                              <td >
                                {checkStockIsAdded(stock) ? (
                                  <Form.Check
                                    type="checkbox"
                                    checked
                                    disabled
                                  />
                                ) : (
                                  <Form.Check
                                    type="checkbox"
                                    checked={isSelectAll}
                                  />
                                )}

                              </td>
                              <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                <img
                                  src={imageRender(stock?.image)}
                                  alt=""
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    background: "gold",
                                  }}
                                />
                              </td>
                              <td style={{ verticalAlign: "middle" }}> {stock?.name}</td>
                              <td style={{ verticalAlign: "middle" }}>{stock?.cfMessage ?? ""}</td>
                              <td style={{ verticalAlign: "middle" }}> {stock?.amount} {stock?.unit}</td>
                              <td style={{ verticalAlign: "middle" }}>
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
                                  {checkStockIsAdded(stock) ?
                                    <a className="btn"
                                      style={{ color: "#616161" }}>ເພີ່ມແລ້ວ</a> :
                                    stock?.amount != 0 ? <a className="btn hoverme"
                                      disabled={isSelectAll}
                                      onClick={() => {
                                        if (isSelectAll) return;
                                        _addStockToLive(stock);
                                      }}
                                      style={{
                                        borderColor: !isSelectAll ? COLOR_APP : "grey",
                                        color: !isSelectAll ? COLOR_APP : "grey",
                                        cursor: !isSelectAll ? "pointer" : "no-drop",
                                      }}>
                                      <FontAwesomeIcon icon={faPlus} style={{ color: !isSelectAll ? COLOR_APP : "grey" }} /> ເພີ່ມ</a> : <div />}
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                }

              </div>
              <div className="product_wrapper">
                <div style={{ display: "flex", justifyContent: 'space-between' }}>
                  <h1>ສິນຄ້າໃນໂພສ ({postStocks?.length})</h1>

                  <Button
                    disabled={!isRemoveAll}
                    style={{
                      color: "#D21C1C",
                      fontSize: "16px",
                      padding: "4px 12px",
                      borderRadius: "6px",
                      background: "#F7F7F7",
                      border: "none"
                    }}
                    onClick={() => onRemoveAllStocksToPost()}
                  >
                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: 5 }} />
                    ນຳອອກ
                  </Button>
                </div>
                <div>
                  {
                    postStocks?.length == 0 ? (<>
                      <div className="no_product">
                        <img src={no_product} alt="" />
                        <h1>ເພີ່ມສິນຄ້າເຂົ້າໃນໂພສ</h1>
                      </div>
                    </>) : (<>
                      {/* <div style={{ padding: 15, marginLeft: "80%" }}>
   
                 </div> */}
                      <Table>
                        <tbody>
                          <tr>
                            <th style={{ width: "1%" }}>
                              <input id="btn-disable" type="checkbox" checked={isRemoveAll} onClick={() => onRemoveAllStocks()} />
                            </th>
                            {/* <th style={{ width: "5%", textAlign: "center" }}>ຮູບ</th> */}
                            <th style={{ verticalAlign: "middle" }}> ຊື່ສິນຄ້າ</th>
                            <th style={{ verticalAlign: "middle" }}>ລະຫັດCF</th>
                            <th style={{ verticalAlign: "middle" }}>ຈໍານວນ</th>
                            <th style={{ verticalAlign: "middle" }}>ຈັດການ</th>
                          </tr>
                        </tbody>
                        <tbody>
                          {postStocks?.length > 0 &&
                            postStocks?.map((lStock, index) => (
                              <tr key={lStock + index}>
                                <td>
                                  <Form.Check
                                    type="checkbox"
                                    checked={isRemoveAll}
                                  />
                                </td>
                                <td>
                                  <pre
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: 14,
                                      margin: 0,
                                    }}
                                  >
                                    {lStock?.stock?.name}
                                  </pre>
                                  {lStock?.stock?.optionValues.map((dd, kIndex) => (
                                    <pre
                                      key={"option" + kIndex + index}
                                      style={{ margin: 0, fontSize: 12 }}
                                    >
                                      {dd.name + ":" + dd.value}
                                    </pre>
                                  ))}
                                </td>
                                {/* <td>{lStock?.cfMessage ?? ""}</td> */}
                                <td>

                                  <Form.Control
                                    type="text"
                                    onChange={(e) => {
                                      _liveStockCFMessageChange(lStock, index, e);
                                    }}
                                    value={postStocks[index].cfMessage}
                                    placeholder="CFລະຫັດ..."
                                  />
                                  {checkSameCode(index).length > 0 && (
                                    <span style={{ color: "red", fontSize: 12 }}>
                                      ລະຫັດCFຕ້ອງບໍ່ຊໍ້າກັນ​!
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <Form.Control
                                    type="number"
                                    onChange={(e) => {
                                      _liveStockChange(lStock, index, e);
                                    }}
                                    value={postStocks[index].amount}
                                    placeholder="ຈໍານວນ..."
                                  />
                                </td>
                                <td>
                                  <Button
                                    className="btn btn-danger"
                                    onClick={() => _removeStockFromLive(lStock)}
                                    style={{
                                      color: "#fff",
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </Button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </>)
                  }
                </div>
              </div>
            </div>

          </div>
        </div>
        ) : (
          <div style={{ margin: '60px 10px 10px 10px', }}>
            <div style={{ background: '#eee', padding: '5px 8px', borderRadius: 3, display: 'flex', justifyContent: 'start' }}>
              <div>
                <button
                  onClick={() => history.push("/post-feed")}
                  style={{
                    fontSize: "16px",
                    color: "#371895",
                    marginRight: "5px",
                    border: 'none',

                  }}
                >
                  <img
                    src={Group}
                    alt=""
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "7px",
                    }}
                  />
                  ຈັດການໜ້າຟີດ
                </button>
              </div>
              <button
                style={{
                  margin: "0 0px",
                  fontSize: "16px",
                  color: "#252A31",
                  border: 'none',
                  cursor: "default",
                }}
              >
                {editMode ? ' / ແກ້ໄຂ' : 'ສ້າງ'}ສິນຄ້າໃໝ່ໃນໂພສ
              </button>
            </div>
            <div style={{ display: 'flex', marginBottom: '10px', alignItems: 'center', width: '100%', padding: '10px 10px', border: "1px solid #eee", marginTop: 20 }}>
              <div className="mr-2">
                ເພຈ:
              </div>
              <div className="form-control mr-2" style={{ fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: 'nowrap', background: '#eee', border: 'none', padding: '8px 15px' }}>
                {selectedPageName ? selectedPageName : liveData?.pageName === "undefined" || liveData?.pageName === "" ? "ກະລຸນາເລືອກເພຈກ່ອນ" : liveData?.pageName ?? "ກະລຸນາເລືອກເພຈກ່ອນ"}
              </div>
              <button
                style={{
                  background: "#F7F7F7",
                  color: "#422F90",
                  border: "1px solid #422F90 ",
                  display: 'flex',
                  alignItems: "center",
                  marginRight: '5px',
                  padding: "4px 6px",
                  whiteSpace: 'nowrap'
                }}
                onClick={() => {
                  // if (!fbUserAccessToken) return addToast(
                  //   "ກະລຸນາເຊື່ອມ Facebook ກ່ອນ!",
                  //   {
                  //     appearance: "error",
                  //     autoDismiss: true,
                  //   }
                  // );
                  triggerShowSelect();
                }}
              >
                ເລືອກເພຈ
              </button>
            </div>
            <div style={{ display: 'flex', marginBottom: '20px', alignItems: 'center', width: '100%', padding: '10px 10px', border: "1px solid #eee", marginTop: 20 }}>
              <div className="mr-2">
                ໂພສ:
              </div>
              <div className="form-control mr-2" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: 'nowrap', maxLines: 2, background: '#eee', border: 'none', fontSize: 12, padding: '8px 15px' }}>
                {selectedPostDescription ? selectedPostDescription : liveData?.description === "undefined" || liveData?.description === "" ? "ກະລຸນາເລືອກໂພສກ່ອນ" : liveData?.description ?? "ກະລຸນາເລືອກໂພສກ່ອນ"}
              </div>
              <button
                style={{
                  background: "#F7F7F7",
                  color: "#422F90",
                  border: "1px solid #422F90 ",
                  display: 'flex',
                  alignItems: "center",
                  marginRight: '5px',
                  padding: "4px 6px",
                  whiteSpace: 'nowrap'
                }}
                onClick={() => {
                  if (_.isEmpty(selectedPageId)) return addToast(
                    "ກະລຸນາເລືອກ Page ໃດຫນຶ່ງ ກ່ອນ!",
                    {
                      appearance: "error",
                      autoDismiss: true,
                    }
                  );
                  triggerShowPost();
                }}
              >
                ເລືອກໂພສ
              </button>
            </div>

            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between' }}>
              <div style={{ fontWeight: 'bold' }}>ລາຍການສິນຄ້າ ({postStocks?.length})</div>
              <button
                style={{
                  background: "#F7F7F7",
                  color: "#422F90",
                  border: "1px solid #422F90 ",
                  borderRadius: "4px",
                  display: 'flex',
                  alignItems: "center",
                  padding: "5px 10px"
                }}
                onClick={() => setshowStockModal(true)}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  style={{ marginRight: 5 }}
                />{" "}
                ເພີ່ມສິນຄ້າ
              </button>
            </div>

            <div style={{ background: '#eee', padding: '5px 8px 5px 0px', marginTop: '20px', display: 'flex', whiteSpace: 'nowrap' }}>
              <div className="col-1">#</div>
              <div className="col-3">ຊື່ສິນຄ້າ</div>
              <div className="col-3">ລະຫັດCF</div>
              <div className="col-3">ຈໍານວນ</div>
              <div className="col-2">ຈັດການ</div>
            </div>

            {
              postStocks.length > 0 && postStocks.map((pStock, index) =>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div key={index} style={{ alignItems: 'center', padding: '10px 8px 5px 0px', margin: '0px', display: 'flex', whiteSpace: 'nowrap' }}>
                    <div className="col-1">{index + 1}</div>
                    <div className="col-3">{pStock?.stock?.name}</div>
                    <div className="col-3" style={{ whiteSpace: 'nowrap' }}><Form.Control
                      type="text"
                      onChange={(e) => {
                        _liveStockCFMessageChange(pStock, index, e);
                      }}
                      value={pStock?.cfMessage}
                      placeholder="CFລະຫັດ..."
                    />
                      {checkSameCode(index).length > 0 && (
                        <span style={{ color: "red", fontSize: 12 }}>
                          ລະຫັດCFຕ້ອງບໍ່ຊໍ້າກັນ​!
                        </span>
                      )}</div>
                    <div className="col-3"><Form.Control
                      type="number"
                      onChange={(e) => {
                        _liveStockChange(pStock, index, e);
                      }}
                      value={pStock?.amount}
                      placeholder="ຈໍານວນ..."
                      style={{ width: '98%', textAlign: 'center' }}
                    /></div>
                    <div className="col-2">
                      <Button
                        className="btn btn-danger"
                        onClick={() => _removeStockFromLive(pStock)}
                        style={{
                          color: "#fff",
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </div>
                  </div>
                  <div style={{ width: '100%', height: 2, background: '#eee' }} />
                </div>)
            }
            <div style={{ height: 50 }} />
            <div style={{ margin: 0, height: '40px', width: '100%', display: 'flex' }} className="floating-container">
              <Button onClick={() => {
                if (!selectedPageId) return addToast(
                  "ກະລຸນາເລືອກ Page ໃດຫນຶ່ງກ່ອນ!",
                  {
                    appearance: "error",
                    autoDismiss: true,
                  }
                );
                if (!selectedPostId) return addToast(
                  "ກະລຸນາເລືອກ Post ໃດຫນຶ່ງກ່ອນ!",
                  {
                    appearance: "error",
                    autoDismiss: true,
                  }
                );
                if (postStocks?.length <= 0) return addToast(
                  "ກະລຸນາເລືອກສິນຄ້າເຂິ້າ Post ກ່ອນ ຈຶ່ງສາມາດເລີ່ມ Post ໄດ້!",
                  {
                    appearance: "error",
                    autoDismiss: true,
                  }
                );
                if (postStocks.length > 0) {
                  editMode ? _editPost() : _createPost();
                  return;
                }
              }} style={{ margin: '2px', background: COLOR_APP, border: 'none', color: '#fff', padding: '3px 10px', width: '100%' }}>
                {isLoading ? <Spinner
                  size="sm"
                  animation="border"
                /> : <div><FontAwesomeIcon className="mr-2" icon={faSave} /> ບັນທຶກ</div>}
              </Button>
            </div>
            <Modal
              show={showStockModal}
              onHide={() => setshowStockModal(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>ລາຍການສິນຄ້າ ({stockTotal})</Modal.Title>

              </Modal.Header>
              <Modal.Body style={{ overflowY: 'auto' }}>
                <div className="d-flex flex-column justify-content-start align-items-start gap-2">

                  <div className="w-100 d-flex justify-content-between">
                    <Dropdown>
                      <Dropdown.Toggle variant="light" id="dropdown-basic">
                        ສະແດງ {perPageLimit}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handlePerPageChange(150)}>150/ໜ້າ</Dropdown.Item>
                        <Dropdown.Item onClick={() => handlePerPageChange(800)}>800/ໜ້າ</Dropdown.Item>
                        <Dropdown.Item onClick={() => handlePerPageChange(1000)}>1000/ໜ້າ</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <button
                      style={{
                        background: "#F7F7F7",
                        color: "#422F90",
                        border: "1px solid #422F90 ",
                        borderRadius: "4px",
                        display: 'flex',
                        alignItems: "center",
                        padding: "5px 10px"
                      }}
                      onClick={() => onAddAllStocksToPost()}
                    >
                      <FontAwesomeIcon
                        icon={faPlus}
                        style={{ marginRight: 5 }}
                      />{" "}
                      ເພີ່ມສິນຄ້າ
                    </button>
                  </div>
                  <PaginationsV1
                    count={stockTotal}
                    perPageLimit={perPageLimit}
                    page={page}
                    pageAll={pageAll}
                    onPageChange={handleChangePage}
                    textNext=">"
                    textPrev="<"
                  />
                </div>
                {(userStockLoading && !userStockData) ? <LoadingSpinner /> :
                  <div style={{ background: '#eee', alignItems: 'center', padding: '5px 20px 5px 0px', display: 'flex', whiteSpace: 'nowrap' }}>

                    <div className="col-1">
                      <input id="btn-disable" type="checkbox" checked={isSelectAll} onClick={() => onSeletedAllStocks()} />
                    </div>
                    <div className="col-2">ຮູບ</div>
                    <div className="col-3">ຊື່ສິນຄ້າ</div>
                    <div className="col-3">ລະຫັດCF</div>
                    <div className="col-2">ຈໍານວນ</div>
                  </div>
                }

                {
                  stockList.length > 0 && stockList.map((stock, index) =>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div key={index} style={{ alignItems: 'center', padding: '10px 20px 5px 0px', margin: '0px 0px 5px 0px', display: 'flex', whiteSpace: 'nowrap' }}>
                        <div className="col-1">

                          <Form.Check
                            onClick={() => {
                              onSelectStock(stock);
                            }}
                            type="checkbox"
                            checked={isSelectAll ? isSelectAll : checkStockIsAddedOnPhone(stock)}
                          />

                        </div>
                        <div className="col-2"><img
                          src={imageRender(stock?.image)}
                          alt=""
                          style={{
                            width: "30px",
                            height: "30px",
                            background: "gold",
                          }}
                        /></div>
                        <div className="col-3" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>{stock?.name ?? '-'}</div>
                        <div className="col-3">{stock?.cfMessage ?? '-'}</div>
                        <div className="col-2">{stock?.amount}</div>
                      </div>
                      <div style={{ width: '100%', height: 2, background: '#eee' }} />
                    </div>
                  )
                }
              </Modal.Body>
            </Modal>
          </div>)
      }
      <Modal
        show={showSelect}
        onHide={triggerHideSelectPage}
      >
        <Modal.Header>
          <Modal.Title
            style={{
              padding: "10px 0.5px 0px 0.5px",
              color: "#00072B",
              fontSize: "16px",
            }}
          >
            ເລືອກເພຈ
          </Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>
          {assignedPageList?.length > 0 ? (
            <>
              {assignedPageList.map((item, index) => (
                <div onClick={() => {
                  setSelectedPageId(item?.id);
                  handleSelectThisPage(item)
                }} key={index} style={{ background: liveData?.pageName === item?.name ? "#ddd" : "#fff" }} className="card-page-selected">
                  <img src="https://cdn-icons-png.flaticon.com/512/11820/11820184.png" style={{ width: 45, height: 45, borderRadius: "50em", overflow: 'hidden', border: '1px solid #f2f2f2' }} />
                  <p style={{ fontSize: 18, fontWeight: 'bold' }}>{item?.name}</p>
                </div>
              ))}
            </>
          ) : (
            <div className="w-100 p-4 d-flex justify-content-center align-items-center flex-column gap-2">
              <img src="https://i.pinimg.com/736x/03/c1/59/03c1592000149644661c721f5aed48fb.jpg" alt="empty page" style={{ maxWidth: 135, maxHeight: 135, }} />
              <p>ກະລຸນາເຊື່ອມຕໍ່ Facebook ກ່ອນ</p>
            </div>
          )}

        </Modal.Body> */}

        <Modal.Body>
          {
            assignedPageList?.length > 0 ? (
              <Form.Control
                as="select"
                value={selectedPage ? selectedPage?.id : liveData?.page}
                onChange={(e) => _changeSeletedPage(e, 1, liveData)}
              >
                <option value="">
                  ເລືອກເພຈເຊື່ອມຕໍ່
                </option>
                {assignedPageList?.map((page, pIndex) => {
                  return (
                    <option
                      value={page?.id}
                      key={"page" + pIndex}
                    >
                      {page?.name}
                    </option>
                  );
                })}
              </Form.Control>
            ) : (
              <p>ກະລຸນາເຊື່ອມຕໍ່
                ກ່ອນ</p>
            )
          }
          <div
            style={{
              textAlign: "center",
              alignItems: "center",
              marginTop: "27px",
            }}
          >
            <Button
              variant="secondary"
              onClick={triggerHideSelectPage}
              style={{
                background: "#E8EDF1",
                color: "#252A31",
                border: "none",
                marginRight: "10px",
                width: "62px",
                height: "33px",
                fontSize: "12px",
              }}
            >
              ຍົກເລີກ
            </Button>
            <Button
              variant="primary"
              onClick={() => _onSavePage()}
              style={{
                background: "#371895",
                color: "#FFFFFF",
                border: "none",
                width: "59px",
                height: "33px",
                textAlign: "center",
                fontSize: "12px",
              }}
            >
              ບັນທຶກ
            </Button>
          </div>
        </Modal.Body>
      </Modal>


      <Modal size="lg" show={showPost} onHide={triggerHidePost} centered>
        <Modal.Header style={{ display: "flex", flexDirection: 'column', justifyContent: "center" }}>
          <div style={{ fontSize: "22px" }}>ຄົ້ນຫາໂພສຂອງທ່ານ</div>
          <Form.Control
            type="text"
            name="searchPostKeyword"
            placeholder="ຄົ້ນຫາຕາມຫົວຂໍ້ໂພສ..."
            onChange={(e) => setSearchPostKeyword(e.target.value)}
          />
        </Modal.Header>
        <Modal.Body
          style={{
            marginLeft: "0px",
            background: "white",
          }}
        >
          <div
            className="row"
            id="example"
            style={{ overflowY: "scroll", height: "50vh" }}
          >
            {
              !assignedPageFeed || isLoadingFeed ?
                <div style={{ textAlign: 'center' }}>
                  <LoadingSpinner />
                </div> :
                assignedPageFeed.length <= 0 ? <div style={{ textAlign: 'center' }}><h5>ຍັງບໍ່ມີໂພສ</h5></div> :
                  assignedPageFeed.map((post) => {
                    return (
                      <div className="col-md-4 mb-4" onClick={() => { _changeSeletedFeed(post?.id); }}>
                        <div
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #DFE2E9",
                            position: 'relative',
                            textOverflow: "ellipsis",
                          }}
                        >
                          <input
                            onChange={(e) => { _changeSeletedFeed(e.target.value); }}
                            value={post?.id}
                            checked={selectedFeed?.id === post?.id}
                            type="checkbox"
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "5px"
                            }}
                          />
                          <img
                            src={post?.full_picture ?? 'images/noPhoto.png'}
                            height="220px"
                            width="100%"
                            alt=""
                            style={{
                              objectFit: "cover"
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              textOverflow: "ellipsis",
                              margin: "0",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              marginLeft: "10px",
                            }}
                          >
                            <p
                              style={{
                                textOverflow: "ellipsis",
                                margin: "0",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                width: "120px",
                              }}
                            >
                              {" "}
                              {post?.message ?? '-'}
                            </p>
                            <p style={{ margin: "0" }}>
                              <FontAwesomeIcon
                                icon={faClock}
                                color="#5C5C5C"
                                fontSize="15px"
                              />
                              <span style={{ marginLeft: "5px" }}>
                                {moment(post?.created_time).format("DD/MM/YYYY  HH:mm")}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })
            }
          </div>

          <div className="p-2 d-flex justify-content-between w-100">
            <Button size="sm" variant="outline-secondary" onClick={handlePrevPage} disabled={prevPage?.length <= 1 ? true : false}>
              <MdOutlineNavigateBefore style={{ fontSize: 26 }} />
            </Button>
            <Button size="sm" variant="outline-secondary" onClick={handleNextPage} disabled={!nextPage}>
              <MdOutlineNavigateNext style={{ fontSize: 26 }} />
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div
            style={{
              display: "flex",
            }}
          >
            <Button
              onClick={triggerHidePost}
              // variant="secondary"
              style={{
                marginRight: "8px",
                width: 72,
                height: 40,
                color: " #252A31",
                background: "#E8EDF1",
                border: "0px",
              }}
            >
              ຍົກເລີກ
            </Button>
            <Button
              onClick={_onSavePostFeed}
              id="btn-disable"
              variant="primary"
              style={{
                // marginRight: "8px",
                width: 125,
                height: 40,
                background: "#422F90",
              }}
            >
              ຢືນຢັນ
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div >
  );
}

const mapStateToProps = (state) => {
  return {
    fbdata: state.fbdata,
  };
};



export default connect(mapStateToProps)(PostFeedAdd);
